var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcNaviFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 15,
    height: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2727 1.5L8.86364 4.90909V12.4091L12.2727 9.34091V1.5ZM13.6364 4.22727V13.4318C12.8864 13.1932 12.0682 13.0909 11.25 13.0909C10.0909 13.0909 8.42045 13.5341 7.5 14.1136V4.90909C6.51136 4.15909 5.07955 3.88636 3.75 3.88636C2.42045 3.88636 0.988636 4.15909 0 4.90909V14.8977C0 15.0682 0.170455 15.2386 0.340909 15.2386C0.409091 15.2386 0.443182 15.2045 0.511364 15.2045C1.43182 14.7614 2.76136 14.4545 3.75 14.4545C5.07955 14.4545 6.51136 14.7273 7.5 15.4773C8.42045 14.8977 10.0909 14.4545 11.25 14.4545C12.375 14.4545 13.5341 14.6591 14.4886 15.1705C14.5568 15.2045 14.5909 15.2045 14.6591 15.2045C14.8295 15.2045 15 15.0341 15 14.8636V4.90909C14.5909 4.60227 14.1477 4.39773 13.6364 4.22727ZM6.13636 13.3705C5.28409 13.1523 4.43182 13.0909 3.75 13.0909C3.02727 13.0909 2.16818 13.2205 1.36364 13.4318V5.67955C1.98409 5.40682 2.82273 5.25 3.75 5.25C4.67727 5.25 5.51591 5.40682 6.13636 5.67955V13.3705Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNaviFaq);
export default __webpack_public_path__ + "static/media/ic-navi-faq.e784ea7324ae61b8f89e121e97f5e702.svg";
export { ForwardRef as ReactComponent };